import React from 'react';
import { useState, useEffect } from 'react';
import customHeaders, { getSpace } from '../../../../../common/headers';
import useGeneralStore from '../../../../../store/general';
import { ButtonClose, InputDinamycPlaceholder, DropDownSelector, ButtonBasic, Checkbox } from "@lk-gtcom/ecomlab-components";
import { TitlePage } from '../../../../../components/TitlePage/TitlePage';
import { ModalAddContactCRM } from '../../ContactCRM/ModalAddContactCRM/ModalAddContactCRM';
import { DynamicFormComponent } from '../../../../../components/DynamicFormComponent/DynamicFormComponent';
import { ModalAddCustomServicesCRM } from '../ModalAddCustomServicesCRM/ModalAddCustomServicesCRM';
import { usePushNotifications } from '../../../../../common/pushNotification';
import { CardContract } from '../CardContract/CardContract';
import { DateBox } from '../../../../../components/DateBox/DateBox';
import { ContactCRMСhoice } from '../../ContactCRM/ContactCRMСhoice';
import ContactCard from '../../../../ComponentsCommonTasksLogic/ModalAddTask/ContactCard/ContactCard';
import { ModalComponent } from '../../../../../components/Modal/ModalComponent/ModalComponent';
import './ModalAddContractCRM.scss'

interface ModalAddContractCRMProps {
    setIsModal: (e: boolean) => void
    currentContract: number | null
    setCurrentContract: (e: number | null) => void
    currentDeal: number | string | null
    setCurrentDeal: (e: number | string | null) => void
}

const ModalAddContractCRM = ({
    setIsModal,
    currentContract,
    setCurrentContract,
    currentDeal,
    setCurrentDeal
}: ModalAddContractCRMProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    const [isModalContact, setIsModalContact] = useState(false)
    const [isMainContact, setIsMainContact] = useState(true)

    // Обработка ошибок
    const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();

    const [idContract, setIdContract] = useState(null)

    const [number, setNumber] = useState('')
    const [date, setDate] = useState(new Date());
    const [accountName, setAccountName] = useState('')
    const [email, setEmail] = useState('')
    const [total, setTotal] = useState('')
    const [totalMonth, setTotalMonth] = useState('')
    const [comment, setComment] = useState('')
    const [edo, setEdo] = useState(false)
    const [mailingEdo, setMailingEdo] = useState(false)
    const [isBillingReport, setIsBillingReport] = useState(false)
    const [active, setActive] = useState(false)
    const [communication, setCommunication] = useState('')
    const [address, setAddress] = useState('')
    const [executors, setExecutors] = useState([]);

    const [initLoadDate, setInitLoaderDate] = useState(true);

    // Первоначальная загрузка
    const [initLoadExecutor, setInitLoaderExecutor] = useState(true);

    const [executorOptions, setExecutorOptions] = useState([]);

    const [services, setServices] = useState([])
    const [contacts, setContacts] = useState([])
    const [isModalContactCRM, setIsModalContactCRM] = useState(false)
    const [isModalCustomServices, setIsModaCustomServices] = useState(false)

    const [contactList, setContactList] = useState([])
    const [contactPage, setContactPage] = useState(1);
    const [contactPage2, setContactPage2] = useState(1);
    const [contactQuery, setContactQuery] = useState('');
    const [contactQuery2, setContactQuery2] = useState('');
    const [selectedContact, setSelectedContact] = useState(null)
    const [selectedContact2, setSelectedContact2] = useState(null)

    const [servicesList, setServicesList] = useState([])
    const [servicesPage, setServicesPage] = useState(1);
    const [servicesQuery, setServicesQuery] = useState('');
    const [selectedServices, setSelectedServices] = useState(null)
    const [servicesListAdded, setServicesListAdded] = useState([])

    const [companyList, setCompanyList] = useState([])
    const [companyPage, setCompanyPage] = useState(1);
    const [companyQuery, setCompanyQuery] = useState('');
    const [selectedCompany, setSelectedCompany] = useState(null)

    const [currentCustomService, setCurrentCustomService] = useState(null)

    const currentId = idContract ? idContract : currentContract
    const [fields, setFilds] = useState([]);

    const [load, setLoad] = useState(false)

    const currentContactList = contactList?.map(({ id, name, company }) => ({ label: name, value: id + (company ? ` (${company})` : '') }))
    const currentCompanyList = companyList?.map(({ id, name }) => ({ label: name, value: id }))
    const currentServicesList = servicesList?.map(({ id, name }) => ({ label: name, value: id }))

    // Получение информации о компании по id
    const fetchGetInfoContract = (): void => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/${currentId}`

        fetch(url, { method: 'GET', headers })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(res.json() as any);
                }
            })
            .then((json) => {
                const { number, edo, mailing_edo, communication, contact, company, active, legal_name, comment, email, total_sum_one_time, total_sum_every_month, manager, additional_contact, billing_report, date } = json
                if (number) setNumber(number)
                if (edo) setEdo(edo)
                if (mailing_edo) setMailingEdo(mailing_edo)
                if (communication) setCommunication(communication)
                if (legal_name) setAccountName(legal_name)
                if (email) setEmail(email)
                if (total_sum_one_time) setTotal(total_sum_one_time)
                if (total_sum_every_month) setTotalMonth(total_sum_every_month)
                if (comment) setComment(comment)
                if (active) setActive(active)
                if (billing_report) setIsBillingReport(billing_report)
                if (date) setDate(new Date(date))
                if (manager) setExecutors([manager])
                if (contact) {
                    setSelectedContact(contact)
                } else {
                    setSelectedContact(null)
                }
                if (additional_contact) {
                    setSelectedContact2(additional_contact)
                } else {
                    setSelectedContact2(null)
                }
                if (company) {
                    setSelectedCompany({
                        label: company?.name,
                        value: company?.id
                    })
                }
            })
            .catch((err) => {
                console.error(err);
            });
    };

    // Создание пустого договора
    const fetchCreateNewContract = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/`

        fetch(url, { method: 'POST', headers })
            .then((res) => res.json())
            .then((json) => {
                setIdContract(json)
                setCurrentContract(json)
            })
            .catch((err) => console.error(err));
    };

    // Удаление договора
    const fetchDeleteContract = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/${currentId}`

        fetch(url, { method: 'DELETE', headers })
            .then((res) => res.json())
            .then((json) => {
                setIdContract(json)
            })
            .catch((err) => console.error(err));
    };

    // Добавить номера договора
    const fetchSetNumber = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/number`

        const body = JSON.stringify({
            contract_id: currentId,
            number
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`number changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить дату
    const fetchSetDate = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/date`

        const body = JSON.stringify({
            contract_id: currentId,
            date
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`date changed`)
            })
            .catch((err) => console.error(err));
    };


    // Добавить наименование для счета
    const fetchSetAccountName = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/legal_name`

        const body = JSON.stringify({
            contract_id: currentId,
            legal_name: accountName
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`number changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить почту
    const fetchSetEmail = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/email`

        const body = JSON.stringify({
            contract_id: currentId,
            email: email
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`number changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить всего сумма
    const fetchSetTotal = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/total_sum_one_time`

        const body = JSON.stringify({
            contract_id: currentId,
            total_sum_one_time: total
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`number changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить всего сумма за месяц
    const fetchSetTotalMonth = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/total_sum_every_month`

        const body = JSON.stringify({
            contract_id: currentId,
            total_sum_every_month: totalMonth
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`number changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить менеджера
    const fetchSetManager = (manager_id: number) => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/manager`

        const body = JSON.stringify({
            contract_id: currentId,
            manager: manager_id
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
            })
            .catch((err) => console.error(err));
    };

    // Добавить комментарий
    const fetchSetComment = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/comment`

        const body = JSON.stringify({
            contract_id: currentId,
            comment: comment
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`number changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить коммуникацию компании
    const fetchSetCommunication = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/communication`

        const body = JSON.stringify({
            contract_id: currentId,
            communication
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`сommunication changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить эдо
    const fetchSetEdo = (edo: boolean) => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/edo`

        const body = JSON.stringify({
            contract_id: currentId,
            edo
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`edo changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить рассылки эдо
    const fetchSetMailingEdo = (mailing_edo: boolean) => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/edo_mailing`

        const body = JSON.stringify({
            contract_id: currentId,
            mailing_edo
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`mailing-edo changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить рассылки эдо
    const fetchBillingReport = (billing_report: boolean) => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/`

        const body = JSON.stringify({
            contract_id: currentId
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`billing-report changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить active
    const fetchSetActive = (active: boolean) => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/active`

        const body = JSON.stringify({
            contract_id: currentId,
            active
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`email changed`)
            })
            .catch((err) => console.error(err));
    };

    // Получение контактов к добавлению
    const fetchGetContactList = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/?page=${contactPage}&limit=50&search=${contactQuery}`

        fetch(url, { method: 'GET', headers })
            .then((res) => res.json())
            .then((json) => {
                const { data, total } = json
                if (contactPage > 1) {
                    setContactList((prev) => [...prev, ...(data || [])]);
                } else {
                    setContactList([...(data || [])]);
                }
            })
            .catch((err) => console.error(err));
    };

    // Получение компаний к добавлению
    const fetchGetCompanyList = () => {
        let url = ` https://portals.ecomru.ru/api/crm/companies/?page=${companyPage}&limit=50&search=${companyQuery}`

        fetch(url, { method: 'GET', headers })
            .then((res) => res.json())
            .then((json) => {
                const { data, total } = json
                if (companyPage > 1) {
                    setCompanyList((prev) => [...prev, ...(data || [])]);
                } else {
                    setCompanyList([...(data || [])]);
                }
            })
            .catch((err) => console.error(err));
    };

    // Получение услуг к добавлению
    const fetchGetServicesList = () => {
        let url = ` https://portals.ecomru.ru/api/crm/services/?page=${servicesPage}&limit=${20}&search=${servicesQuery}`

        fetch(url, { method: 'GET', headers })
            .then((res) => res.json())
            .then((json) => {
                const { data, total } = json
                if (servicesPage > 1) {
                    setServicesList((prev) => [...prev, ...(data || [])]);
                } else {
                    setServicesList([...(data || [])]);
                }
            })
            .catch((err) => console.error(err));
    };

    // Получение добавленных услуг
    const fetchGetServicesListAdded = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/${currentId}/services?can_be_add=false&page=${'1'}&limit=${'1000'}`

        fetch(url, { method: 'GET', headers })
            .then((res) => res.json())
            .then((json) => {
                const { data, total } = json
                const selected_services = data?.map(({ id, name }) => ({
                    label: name,
                    value: id
                }))
                // setSelectedServices(selected_services)
            })
            .catch((err) => console.error(err));
    };

    // Получение услуг по договору
    const fetchGetServices = (id: number | string): void => {

        if (!id) return
        let url = ` https://portals.ecomru.ru/api/crm/contracts/${id}/services?can_be_add=false`

        fetch(url, { method: 'GET', headers })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(res.json() as any);
                }
            })
            .then((json) => {
                const { data, total } = json
                setServices(data)
                const selected_contacts = data?.map(({ id, name, phone, email, address }) => ({
                    label: name,
                    value: id,
                    phone, email, address
                }))
                // setSelectedServices(selected_contacts)
            })
            .catch((err) => {
                console.error(err);
            });
    };

    // Получение услуг по договору с информацией
    const fetchGetServicesWidthInfo = (id: number | string): void => {

        if (!id) return
        let url = ` https://portals.ecomru.ru/api/crm/contracts/custom_services/${id}`

        fetch(url, { method: 'GET', headers })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(res.json() as any);
                }
            })
            .then((json) => {
                setServicesListAdded(json)
            })
            .catch((err) => {
                console.error(err);
            });
    };

    // Получение сотрудников из пространства
    const fetchGetClientSpace = () => {
        const url = `https://apps0.ecomru.ru:4242/api/v2/space/users/${selectedSpace?.value}`;

        const body = JSON.stringify({
            name: ""
        });

        fetch(url, { headers, method: 'POST', body })
            .then(async (res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    const err = await res.json();
                    throw new Error(JSON.stringify(err));
                }
            })
            .then((json) => {
                if (json?.data) {
                    setExecutorOptions(json?.data);
                }
            })
            .catch((err) => console.error(err))
    };

    useEffect(() => {
        fetchGetContactList();
    }, [contactPage, contactQuery]);

    useEffect(() => {
        fetchGetServicesList();
    }, [servicesPage, servicesQuery]);

    useEffect(() => {
        fetchGetCompanyList();
    }, [companyPage, companyQuery]);

    // Добавить контакт
    const fetchSetContact = (contact_id) => {
        setLoad(true)
        let url = ` https://portals.ecomru.ru/api/crm/contracts/contact_id`

        const body = JSON.stringify({
            contract_id: currentId,
            contact_id: contact_id || null
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log('added contact')
                fetchGetInfoContract()
                setIsModalContact(false)
            })
            .catch((err) => console.error(err))
            .finally(() => setLoad(false))
    };

    // Добавить дополнительный контакт
    const fetchSetAdditionalContact = (contact_id) => {
        setLoad(true)
        let url = ` https://portals.ecomru.ru/api/crm/contracts/additional_contact`

        const body = JSON.stringify({
            contract_id: currentId,
            additional_contact_id: contact_id
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log('added contact')
                fetchGetInfoContract()
                setIsModalContact(false)
            })
            .catch((err) => console.error(err))
            .finally(() => setLoad(false))
    };

    // Добавить услугу
    const fetchSetServices = (service_id: number | string) => {
        setLoad(true)
        let url = ` https://portals.ecomru.ru/api/crm/contracts/service/add`

        const body = JSON.stringify({
            contract_id: currentId,
            service_id
        });

        fetch(url, { body, method: 'POST', headers })
            .then((res) => res.json())
            .then((json) => {
                addSuccessPush('Услуга добавлена', 2000);
                setTimeout(() => fetchGetServicesWidthInfo(currentId), 1000)
            })
            .catch((err) => console.error(err))
            .finally(() => setLoad(false))
    };

    // Удалить услугу
    const fetchDeleteServices = (custom_service_record_id: number | string) => {
        setLoad(true)
        let url = ` https://portals.ecomru.ru/api/crm/contracts/service/remove`

        const body = JSON.stringify({
            custom_service_record_id,
            bind_service_to_contract_id: 0
        })

        fetch(url, { body, method: 'DELETE', headers })
            .then((res) => res.json())
            .then((json) => {
                setTimeout(() => fetchGetServicesWidthInfo(currentId), 1000)
            })
            .catch((err) => console.error(err))
            .finally(() => setLoad(false))
    };

    // Добавить компанию
    const fetchSetCompany = () => {
        setLoad(true)
        let url = ` https://portals.ecomru.ru/api/crm/contracts/company_id`

        const body = JSON.stringify({
            contract_id: currentId,
            company_id: selectedCompany?.value || null
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log('added contact')
            })
            .catch((err) => console.error(err))
            .finally(() => setLoad(false))
    };

    // Получение доп полей компании
    const fetchGetFieldsList = (id: number | string): void => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/additional_fields/${id}`

        fetch(url, { method: 'GET', headers })
            .then((res) => res.json())
            .then((json) => {
                if (Array.isArray(json)) {
                    setFilds(json?.map(({ name, id, type, value, possible_values }) => ({ front_name: name, data_type: type, id: id, value: value ? JSON?.parse(value) : null, possible_values: possible_values })))
                }
            })
            .catch((err) => console.error(err));
    };

    // Запись полей
    const fetchSetValueField = (id: number | string, value: any): void => {
        let url = ` https://portals.ecomru.ru/api/crm/contracts/additional_fields/${currentId}`

        const body = JSON.stringify({
            field_id: id,
            value: (value !== null || value !== undefined) ? JSON?.stringify(value) : null
        })

        fetch(url, { method: 'POST', headers, body })
            .then((res) => res.json())
            .then((json) => {
                // if (Array.isArray(json)) {
                //     setFilds(json)
                // }
            })
            .catch((err) => console.error(err));
    };

    // Добавить компанию сделку в компанию
    const fetchBindDeal = () => {
        let url = ` https://portals.ecomru.ru/api/crm/deals/contract`

        const body = JSON.stringify({
            deal_id: currentDeal,
            contract_id: currentId
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log('Компания добавлена в сделку')
            })
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        if (!initLoadDate) {
            fetchSetDate();
            setInitLoaderDate(false);
        }
    }, [date]);

    useEffect(() => {
        if (!isModalCustomServices) {
            setTimeout(() => fetchGetServicesWidthInfo(currentId), 500)
        }
    }, [isModalCustomServices]);

    useEffect(() => {
        fetchGetClientSpace()
        if (currentContract) {
            fetchGetInfoContract()
            fetchGetServicesListAdded()
        } else {
            fetchCreateNewContract()
        }
    }, [currentContract]);

    useEffect(() => {
        if (currentId && !isModalContactCRM) {
            fetchGetServices(currentId)
            fetchGetFieldsList(currentId)
        }
    }, [currentId, isModalContactCRM]);

    // useEffect(() => {
    //     if (currentId) {
    //         fetchBindDeal()
    //     }
    // }, [currentDeal, currentId]);

    const onClose = () => {
        if (!number) {
            fetchDeleteContract()
        }
        setCurrentContract(null)
        setCurrentDeal(null)
        setIsModal(false)
    }

    useEffect(() => {
        if (!initLoadExecutor) {
            if (Array.isArray(executors)) {
                fetchSetManager(executors[0]?.id ? executors[0]?.id : null);
            }
        }
    }, [executors]);

    return (
        <>
            {isModalContactCRM && <ModalAddContactCRM
                currentContract={currentContract}
                isModal={false}
                setIsModal={setIsModalContactCRM}
            />}

            {/* Кастомные услуги */}
            {isModalCustomServices && <ModalAddCustomServicesCRM
                setIsModal={setIsModaCustomServices}
                currentCustomService={currentCustomService}
                setCurrentCustomService={setCurrentCustomService}
            />}

            {isModalContact && <ContactCRMСhoice
                modal
                setIsModal={setIsModalContact}
                addContact={isMainContact ? fetchSetContact : fetchSetAdditionalContact}
            />}

            <ModalComponent
                right
                onClose={onClose}
                title={currentContract ? 'Редактирование договора' : 'Добавление договора'}
                child={
                    <div className='modal-add-contract-CRM'>
                        <div className='modal-add-contract-CRM__main-content'>

                            <TitlePage
                                medium
                                title={'Основная информация'}
                            />

                            <div className='modal-add-contract-CRM__content'>
                                <InputDinamycPlaceholder
                                    placeholder='Номер'
                                    onChange={(e) => setNumber(e)}
                                    changeValue={number}
                                    onBlur={fetchSetNumber}
                                    size='s'
                                    required
                                />

                                <div
                                    onBlur={(e) => {
                                        if (initLoadDate) {
                                            setInitLoaderDate(false);
                                        }
                                    }}
                                >
                                    <DateBox
                                        disabled={false}
                                        startDate={date}
                                        description={'Дата'}
                                        setStartDate={(e) => {
                                            setDate(e);
                                        }}
                                        size='s'
                                    // onBlur={fetchSetDate}
                                    />
                                </div>



                                {/* <InputDinamycPlaceholder
                                placeholder='Юридическое название для счета'
                                onChange={(e) => setAccountName(e)}
                                changeValue={accountName}
                                onBlur={fetchSetAccountName}
                                size='s'
                            /> */}

                                {/* <InputDinamycPlaceholder
                                placeholder='Почта'
                                onChange={(e) => setEmail(e)}
                                changeValue={email}
                                onBlur={fetchSetEmail}
                                size='s'
                            /> */}

                                {/* <InputDinamycPlaceholder
                                type='number'
                                placeholder='Единовременная сумма'
                                onChange={(e) => setTotal(e)}
                                changeValue={total}
                                onBlur={fetchSetTotal}
                                size='s'
                            /> */}

                                {/* <InputDinamycPlaceholder
                                type='number'
                                placeholder='Ежемесечная сумма'
                                onChange={(e) => setTotalMonth(e)}
                                changeValue={totalMonth}
                                onBlur={fetchSetTotalMonth}
                                size='s'
                            /> */}

                                {/* <TextareaDynamicPlaceholder
                                placeholder='Комментарии'
                                onChange={(e) => setComment(e)}
                                changeValue={comment}
                                onBlur={fetchSetComment}
                                size='s'
                                width='100%'
                            /> */}

                                {/* <div
                                onClick={(e) => {
                                    if (initLoadExecutor) {
                                        setInitLoaderExecutor(false);
                                    }
                                }}
                            >
                                <SelectExecutor
                                    executors={executors}
                                    setExecutors={(e) => {
                                        setExecutors(e);
                                    }}
                                    executorOptions={executorOptions}
                                    title="Менеджер"
                                    placeholder="Назначить"
                                />
                            </div> */}


                                <Checkbox
                                    value={edo}
                                    onChange={(checked) => {
                                        setEdo(checked)
                                        fetchSetEdo(checked)
                                    }}
                                >ЭДО</Checkbox>

                                <Checkbox
                                    value={mailingEdo}
                                    onChange={(checked) => {
                                        setMailingEdo(checked)
                                        fetchSetMailingEdo(checked)
                                    }}
                                >Добавить рассылку ЭДО договора</Checkbox>

                                <Checkbox
                                    value={isBillingReport}
                                    onChange={(checked) => {
                                        setIsBillingReport(checked)
                                        fetchBillingReport(checked)
                                    }}
                                >Нужен отчет по биллингу для согласования суммы?</Checkbox>

                                {/* <Checkbox
                                value={active}
                                onChange={(checked) => {
                                    setActive(checked)
                                    fetchSetActive(checked)
                                }}
                            >Активно</Checkbox> */}

                                {/* <InputDinamycPlaceholder
                                placeholder='Коммуникация'
                                onChange={(e) => setCommunication(e)}
                                changeValue={communication}
                                onBlur={fetchSetCommunication}
                                size='s'
                            /> */}
                            </div>

                            {fields?.length ? <>
                                <TitlePage
                                    medium
                                    title={'Дополнительные поля'}
                                />

                                <div className='modal-add-contract-CRM__content'>
                                    <DynamicFormComponent
                                        productTemporary={fields}
                                        fetchSetValue={fetchSetValueField as any}
                                    />
                                </div>
                            </> : null}


                            <TitlePage
                                medium
                                title='Контакты'
                            />


                            <div className='modal-add-contract-CRM__contacts-header'>
                                <ButtonBasic
                                    blue
                                    text='+ Добавить контакт'
                                    onClick={(e) => {
                                        setIsMainContact(true)
                                        setIsModalContact(true)
                                    }}
                                />

                                <ButtonBasic
                                    whiteBlue
                                    width='auto'
                                    text='+ Добавить дополнительный контакт'
                                    onClick={(e) => {
                                        setIsMainContact(false)
                                        setIsModalContact(true)
                                    }}
                                />
                            </div>

                            {selectedContact && <div className='modal-add-company-CRM__contacts-cards'>
                                <TitlePage medium title='Контакт' />

                                <div className='modal-add-company-CRM__card-contact'>
                                    <ContactCard
                                        contact={selectedContact}
                                    />

                                    <ButtonClose
                                        xs
                                        onClick={(e) => {
                                            fetchSetContact(null)
                                        }}
                                    />
                                </div>
                            </div>}

                            {selectedContact2 && <div className='modal-add-company-CRM__contacts-cards'>
                                <TitlePage medium title='Дополнительный контакт' />
                                <div className='modal-add-company-CRM__card-contact'>
                                    <ContactCard
                                        contact={selectedContact2}
                                    />

                                    <ButtonClose
                                        xs
                                        onClick={(e) => {
                                            fetchSetAdditionalContact(null)
                                        }}
                                    />
                                </div>
                            </div>}

                            <TitlePage
                                medium
                                title='Услуги'
                            />

                            <div className='modal-add-contract-CRM__contacts-header'>
                                <DropDownSelector
                                    options_prop={currentServicesList}
                                    placeholder="Услуги"
                                    state={selectedServices}
                                    fetchCallback={(e) => setServicesPage(e)}
                                    setInputChange={(e) => setServicesQuery(e)}
                                    disabled={load}
                                    isClearable={false}
                                    setState={(e) => {
                                        // // Определяем, что изменилось
                                        // const added = e?.filter(x => !selectedServices?.some(y => y.value === x.value));
                                        // const removed = selectedServices?.filter(x => !e?.some(y => y.value === x.value));

                                        // if (added?.length > 0) {
                                        //     fetchSetServices(added[0]?.value);
                                        // }
                                        // if (removed?.length > 0) {
                                        //     fetchDeleteServices(removed[0]?.value)
                                        // }
                                        if (e?.value) {
                                            fetchSetServices(e?.value)
                                        }
                                        // setSelectedServices(e);
                                    }}
                                    all={false}
                                />
                            </div>

                            <div className='modal-add-contract-CRM__contacts-cards'>
                                {servicesListAdded?.map(({
                                    name,
                                    unit,
                                    active,
                                    record_id,
                                    price_unit,
                                    amount_unit,
                                    need_report,
                                    payment_part,
                                    payment_type,
                                    payment_period,
                                    additional_fields,
                                    service_id,
                                    comment,
                                    invoice_name
                                }) => {
                                    return <CardContract
                                        name={name}
                                        unit={unit}
                                        active={active}
                                        record_id={record_id}
                                        price_unit={price_unit}
                                        amount_unit={amount_unit}
                                        need_report={need_report}
                                        payment_part={payment_part}
                                        payment_type={payment_type}
                                        payment_period={payment_period}
                                        additional_fields={additional_fields}
                                        service_id={service_id}
                                        comment={comment}
                                        invoice_name={invoice_name}
                                        fetchDeleteServices={fetchDeleteServices}
                                        setCurrentCustomService={setCurrentCustomService}
                                        setIsModaCustomServices={setIsModaCustomServices}
                                    />
                                })
                                }
                            </div>

                            <TitlePage
                                medium
                                title='Компании'
                            />

                            <div className='modal-add-contract-CRM__contacts-header'>
                                <DropDownSelector
                                    options_prop={currentCompanyList}
                                    placeholder="Компания"
                                    state={selectedCompany}
                                    fetchCallback={(e) => setCompanyPage(e)}
                                    setInputChange={(e) => setCompanyQuery(e)}
                                    setState={setSelectedCompany}
                                    onBlur={fetchSetCompany}
                                    disabled={load}
                                />
                            </div>
                        </div>
                    </div>
                }
            />
        </>
    )
}

export { ModalAddContractCRM }